import { put, call } from 'redux-saga/effects';

import { logError } from '@tcc/scarecrow';

import { setLandingPageUrls, setSupportInfo } from 'actions/supportInfoActions';
import { supportInfoRequest } from 'requesters/staticAssetsRequester';
import {
  getLandingPageUrls,
  getReferrerCountryCode,
  extractEmailPhoneNo,
  getCountryCodeFromQueryParam
} from '../utils/supportInfo';

export function getCountryCode(supportInfo) {
  return getCountryCodeFromQueryParam() || getReferrerCountryCode(supportInfo);
}

/* This is performed one time when app loads, so have not followed the
   watcher pattern. Can add it in easily enough if it's needed. */
export function* initSupportInfo() {
  try {
    const supportInfo = yield call(supportInfoRequest);
    const referrerCountryCode = getCountryCode(supportInfo);
    const landingPageUrls = getLandingPageUrls(supportInfo);
    yield put(setLandingPageUrls(landingPageUrls));
    if (referrerCountryCode) {
      const { supportEmail, supportPhoneNumber } =
        extractEmailPhoneNo(supportInfo, referrerCountryCode);
      yield put(setSupportInfo({supportEmail, supportPhoneNumber, referrerCountryCode}));
    }
  } catch (err) {
    // This is not a fatal error, and other code deals with the lack of support info.
    logError(err);
  }
}
